import React from 'react'

function TechApp() {
  return (
    <div style={{
      width: '100vw',
      height: '100vh',
      margin: 0,
      padding: 0,
      overflow: 'hidden',
      background: '#0a0a0f',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <iframe
        src="https://eduallapptechimports.kiossocamuegi.workers.dev"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block',
        }}
        title="app eduall"
      />
    </div>
  )
}

export default TechApp